/**
 * Attendance History Route
 *
 * A parent-friendly page for viewing their swimmers' attendance records.
 */

import { createFileRoute } from "@tanstack/react-router"

import ParentAttendanceHistory from "@/pages/ParentAttendanceHistory"

export const Route = createFileRoute("/_layout/attendance-history")({
  component: ParentAttendanceHistory,
})
